import { render, staticRenderFns } from "./SusAutorizador.vue?vue&type=template&id=a207e9cc&"
import script from "./SusAutorizador.vue?vue&type=script&lang=js&"
export * from "./SusAutorizador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports